<template>
    <div class="pane"
         :class="classes">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'pane',
    props: {
        variant: {},
    },
    computed: {
        classes() {
            return {
                [`pane--variant-${this.variant}`]: this.variant,
            };
        },
    },
};
</script>